export type AlarmLevel = "紧急" | "严重" | "警告" | "提示";
export type AlarmType = "泄漏报警" | "欠费预警" | "设备异常" | "压力异常" | "流量异常" | "安检逾期" | "保险到期" | "通信中断";
export type AlarmStatus = "未处理" | "处理中" | "已处理" | "已忽略";

export interface AlarmRecord {
  id: string;
  type: AlarmType;
  level: AlarmLevel;
  status: AlarmStatus;
  userId: string;
  userName: string;
  userCategory: string;
  deviceId: string;
  deviceType: string;
  address: string;
  message: string;
  value: string;
  threshold: string;
  occurTime: string;
  handleTime?: string;
  handler?: string;
  handleNote?: string;
  pushSent: boolean;
}

export const alarmRecords: AlarmRecord[] = [
  {
    id: "AL20260410001",
    type: "泄漏报警",
    level: "紧急",
    status: "未处理",
    userId: "R002",
    userName: "李秀梅",
    userCategory: "居民用户",
    deviceId: "IOT-R002-AL",
    deviceType: "燃气泄漏报警器",
    address: "北京市海淀区中关村南大街15号1单元301室",
    message: "燃气浓度超过爆炸下限25%，疑似泄漏！",
    value: "25.3% LEL",
    threshold: "10% LEL",
    occurTime: "2026-04-10 14:22:18",
    pushSent: true,
  },
  {
    id: "AL20260410002",
    type: "欠费预警",
    level: "警告",
    status: "未处理",
    userId: "R002",
    userName: "李秀梅",
    userCategory: "居民用户",
    deviceId: "IOT-R002-GM",
    deviceType: "智能燃气表",
    address: "北京市海淀区中关村南大街15号1单元301室",
    message: "账户余额不足，预计3天内用尽",
    value: "¥89.50",
    threshold: "¥100.00",
    occurTime: "2026-04-10 08:00:00",
    pushSent: true,
  },
  {
    id: "AL20260410003",
    type: "压力异常",
    level: "严重",
    status: "处理中",
    userId: "C001",
    userName: "老北京涮肉馆",
    userCategory: "工商业用户",
    deviceId: "IOT-C001-PT",
    deviceType: "压力变送器",
    address: "北京市东城区鼓楼东大街56号",
    message: "管道压力超出正常范围，请立即检查",
    value: "0.18 MPa",
    threshold: "0.15 MPa",
    occurTime: "2026-04-10 11:35:42",
    handleTime: "2026-04-10 11:50:00",
    handler: "张工程师",
    handleNote: "已联系用户，现场排查中",
    pushSent: true,
  },
  {
    id: "AL20260409001",
    type: "通信中断",
    level: "严重",
    status: "已处理",
    userId: "R003",
    userName: "王大明",
    userCategory: "居民用户",
    deviceId: "IOT-R003-GM",
    deviceType: "智能燃气表",
    address: "北京市西城区长安街100号5单元1201室",
    message: "设备超过2小时未上报数据，通信中断",
    value: "离线 2h15m",
    threshold: "离线 > 1h",
    occurTime: "2026-04-09 16:20:00",
    handleTime: "2026-04-09 18:45:00",
    handler: "李工程师",
    handleNote: "网络信号问题，已重启设备，恢复正常",
    pushSent: true,
  },
  {
    id: "AL20260409002",
    type: "安检逾期",
    level: "警告",
    status: "未处理",
    userId: "R002",
    userName: "李秀梅",
    userCategory: "居民用户",
    deviceId: "-",
    deviceType: "-",
    address: "北京市海淀区中关村南大街15号1单元301室",
    message: "安检已逾期54天，请尽快安排安检",
    value: "逾期54天",
    threshold: "0天",
    occurTime: "2026-04-09 09:00:00",
    pushSent: false,
  },
  {
    id: "AL20260408001",
    type: "流量异常",
    level: "警告",
    status: "已处理",
    userId: "C002",
    userName: "北京华联超市（朝阳店）",
    userCategory: "工商业用户",
    deviceId: "IOT-C002-FM",
    deviceType: "涡轮流量计",
    address: "北京市朝阳区朝阳路188号",
    message: "流量突增超过历史均值200%，疑似异常用气",
    value: "856 m³/h",
    threshold: "历史均值 285 m³/h",
    occurTime: "2026-04-08 22:10:33",
    handleTime: "2026-04-08 22:35:00",
    handler: "王工程师",
    handleNote: "确认为大型活动用气，属正常范围，已备注",
    pushSent: true,
  },
  {
    id: "AL20260408002",
    type: "保险到期",
    level: "提示",
    status: "已忽略",
    userId: "R001",
    userName: "张建国",
    userCategory: "居民用户",
    deviceId: "-",
    deviceType: "-",
    address: "北京市朝阳区建国路88号3单元502室",
    message: "燃气安全保险将于90天后到期，请提前续保",
    value: "到期：2026-12-31",
    threshold: "90天预警",
    occurTime: "2026-04-08 09:00:00",
    pushSent: true,
  },
  {
    id: "AL20260407001",
    type: "设备异常",
    level: "严重",
    status: "已处理",
    userId: "C003",
    userName: "北京燃气热力工程设计院",
    userCategory: "工商业用户",
    deviceId: "IOT-C003-FM",
    deviceType: "超声波流量计",
    address: "北京市海淀区西三环北路甲2号",
    message: "流量计电池电量低于5%，需立即更换",
    value: "4.2%",
    threshold: "5%",
    occurTime: "2026-04-07 14:00:00",
    handleTime: "2026-04-07 16:30:00",
    handler: "赵工程师",
    handleNote: "已上门更换电池，设备恢复正常",
    pushSent: true,
  },
];

export const pushSettings = {
  channels: [
    { id: "sms", label: "短信通知", icon: "ri-message-2-line", enabled: true },
    { id: "app", label: "APP推送", icon: "ri-notification-3-line", enabled: true },
    { id: "wechat", label: "微信公众号", icon: "ri-wechat-line", enabled: false },
    { id: "email", label: "邮件通知", icon: "ri-mail-line", enabled: true },
    { id: "voice", label: "语音电话", icon: "ri-phone-line", enabled: false },
  ],
  levelRules: [
    { level: "紧急", sms: true, app: true, voice: true, email: true, wechat: true, autoDispatch: true },
    { level: "严重", sms: true, app: true, voice: false, email: true, wechat: false, autoDispatch: false },
    { level: "警告", sms: false, app: true, voice: false, email: false, wechat: false, autoDispatch: false },
    { level: "提示", sms: false, app: true, voice: false, email: false, wechat: false, autoDispatch: false },
  ],
  thresholds: [
    { type: "泄漏报警", threshold: "10% LEL", unit: "LEL", editable: true },
    { type: "欠费预警", threshold: "100", unit: "元", editable: true },
    { type: "压力异常", threshold: "0.15", unit: "MPa", editable: true },
    { type: "流量异常", threshold: "200", unit: "% 历史均值", editable: true },
    { type: "通信中断", threshold: "60", unit: "分钟", editable: true },
    { type: "安检逾期", threshold: "0", unit: "天", editable: false },
    { type: "保险到期", threshold: "90", unit: "天", editable: true },
  ],
};
